import React from "react";
import { Row, Col, Input, Typography, Form, Button, Grid, message } from "antd";
import contactImg from '../../assets/aboutuscircle2.webp';
import TextArea from "antd/es/input/TextArea";
import "./ContactUsPage.css";

const { Title, Paragraph } = Typography;
const { useBreakpoint } = Grid;

const ContactPage = () => {
    const [form] = Form.useForm();
    const image = '/CSS-logo.png';
    const screens = useBreakpoint();
    
    const handleSubmit = (values) => {
        console.log("Form Submitted:", values);
        
        const contactRequest = {
            name: values.name,
            email: values.email,
            phone: values.phone,
            message: values.description
        };

        const handleContactRequest = async () => {
            fetch("",{ 
                method: 'POST',
                headers: {
                    "Content-Type" : "applicatioon/json",
                    "entityis" : "w_123"
                },
                body: JSON.stringify({contactRequest})
            })
        }
        // handleContactRequest();
    };

    return(
        <div style={{ padding: "40px" }}>
            <Row gutter={[32, 32]} align="middle" justify="center">
                {/* Left Side: Logo and Info */}
                <Col xs={24} md={12} className="contact-image-text">
                    {!screens.xs && 
                    <img
                        src={image}
                        alt="Logo"
                        style={{ width: 200, marginBottom: 10, borderRadius: '50%'}} />}
                    <Title level={3}>Get in Touch</Title>
                    <Paragraph>
                        We'd love to hear from you. Fill in the form and our team will get back to you shortly.
                    </Paragraph>
                </Col>

                {/* Right Side: Contact Form */}
                <Col xs={24} md={12}>
                <Form
                    form={form}
                    layout="vertical"
                    onFinish={handleSubmit}
                    className="form-body"
                >
                    <Form.Item
                    label="Name"
                    name="name"
                    rules={[{ required: true, message: "Please enter your name" }]}
                    >
                    <Input placeholder="Your full name" />
                    </Form.Item>

                    <Row className="form-contact-items">
                        <Col xs={24} xl={10}>
                            <Form.Item
                                label="Phone"
                                name="phone"
                                rules={[
                                    { required: true, message: "Please enter your phone number" },
                                    {
                                    pattern: /^[0-9]{10}$/,
                                    message: "Enter a valid 10-digit phone number",
                                    },
                                ]}
                                >
                                <Input placeholder="Your phone number"/>
                                </Form.Item>
                        </Col>
                        <Col xs={24} xl={12}>
                            <Form.Item
                                label="Email"
                                name="email"
                                rules={[
                                    { required: true, message: "Please enter your email" },
                                    { type: "email", message: "Please enter a valid email" },
                                ]}
                                >
                                <Input placeholder="Your email address" />
                            </Form.Item>
                        </Col>
                    </Row>

                    <Form.Item
                        label="Description"
                        name="description"
                        rules={[
                            { required: true, message: "Please enter your comment" },
                        ]}
                    >
                        <TextArea rows={4} inputMode="text" placeholder="Enter your comment"/>
                    </Form.Item>

                    <Form.Item>
                    <Button type="primary" htmlType="submit" block>
                        Submit
                    </Button>
                    </Form.Item>
                </Form>
                </Col>
            </Row>
            </div>
    )
}
export default ContactPage;